<template>
  <div class="login-wrap">
    <div class="ms-login">
      <div class="ms-title">SP-SRM</div>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px" class="ms-content">
        <el-form-item prop="userCd">
          <el-input v-model="ruleForm.userCd" placeholder="邀请码">
            <el-button slot="prepend" icon="fa fa-user"></el-button>
          </el-input>
        </el-form-item>
        <div class="login-btn">
          <el-button type="primary" @click="submitForm('ruleForm')">登录</el-button>
        </div>
      </el-form>
    </div>

    <el-dialog :visible.sync="showLoginAgreementDialog" append-to-body :close-on-click-modal="false" :showClose="false" width="80%">
      <template v-slot:title>
        <center>
          <h2>麦当劳中国供应商关系管理系统登录声明</h2>
        </center>
      </template>
      <div class="container">
        <div class="handle-box">

          <el-row>
            <el-col :span="24">
              <el-input type="textarea" :rows="25" v-model="loginAgreementText"></el-input>
            </el-col>
          </el-row>
        </div>
        <el-row type="flex" justify="center">
          <el-checkbox v-model="agreeFlag">已阅读并同意登录声明</el-checkbox>
        </el-row>
        <el-row type="flex" justify="center">
          <!--<el-button type="primary" @click="agreeMethod">我已阅读条款并同意</el-button>-->
          <el-button type="primary" :disabled="!agreeFlag" @click="agreeMethod">立即登陆</el-button>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { localLogin } from "../../api/login";
import { setUser } from "@/store/main";
import { userService } from "../../api/user-manage/user";
import { Message } from "element-ui";
export default {
  name: "sp-login",
  data: function () {
    return {
      userInfo: null,
      agreeFlag: false,
      loginAgreementText: "",
      showLoginAgreementDialog: false,
      ruleForm: {
        userCd: ''
      },
      rules: {
        userCd: [
          { required: true, message: '请输入邀请码', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.loginAgreementText =
      "1.\t供应商在金拱门（中国）有限公司或其关联方（“麦当劳中国”）供应商关系管理系统（Supplier Relationship Management System, “SRM System”）中所提交的所有文件以及信息真实、有效、完整，不存在有不实或欺瞒的行为；若经查实，发现供应商提供的信息虚假、无效或者不完整，麦当劳中国有权自行根据其供应商管理规定的要求，对供应商采取相关措施，包括但不限于终止与供应商所签署的采购合同等。\n" +
      "All the documents and information submitted by the supplier in the Supplier Relationship Management System ( \"SRM System\") of M (China) Company Limited ( \"McD China\") are authentic, valid and complete without false or deceptive behavior. If verified the information submit by supplier is false, invalid or incomplete, in accordance with the requirements of McD China, McD China shall take relevant action to the supplier, including but not limited to termination of the procurement contract signed with the supplier. \n" +
      "\n" +
      "2.\t供应商在SRM System中所提交的相关财务信息由供应商负责其正确性，如出现由于银行账号问题导致的付款失败或付款错误均由供应商自行承担。\n" +
      "The financial information submitted by supplier in SRM System, supplier is responsible for its correctness. In the event of payment failure or payment error due to bank account issues, the supplier shall bear the responsibility for the failure.\n" +
      "\n" +
      "3.\t供应商将妥善保管其在SRM System的用户名和账号，因供应商未能保管好自己的账号和密码而造成的损失均由供应商自行承担。供应商若发现任何非法使用其账号、密码的情况，应立即向麦当劳中国报告。\n" +
      "The supplier should keep the user name and account number in the SRM System. Supplier will bear the losses caused by the failure of the supplier to keep the account number and password. If the supplier finds any illegal use of its account number and password, it shall immediately inform McD China.\n" +
      "\n" +
      "4.\t除以下例外情形，SRM System中包含的所有信息均为麦当劳保密信息。在未获取麦当劳中国事先书面许可的情况下，供应商不得以任何方式将SRM System系统中包含的麦当劳保密信息对外披露或用于SRM System系统使用之外的任何用途。麦当劳中国保密信息不包括以下信息或数据：(1) 供应商能证明在收到前已经被供应商或供应商关联机构所知的且并非通过不正当手段获取的任何信息或数据；(2) 供应商能证明已经被公众所知(并非通过不正当手段)的任何信息或数据；(3)由供应商或供应商关联机构在未使用任何麦当劳中国保密信息的条件下为了麦当劳中国或麦当劳中国关联机构以外的一方独立开发的任何信息或数据；或 (4) 经麦当劳中国书面授权批准发布的任何信息或数据。\n" +
      "\n" +
      "\n" +
      "Except provided below, all the information and documents included in the SRM System are McD China Confidential Information. The nature and contents of McD China Confidential Information will not be disclosed by the Supplier in any manner to others or used for any other purpose except for SRM System without the prior written permission of McD China. McD China Confidential Information does not include any information or data that the Supplier can demonstrate (1) is already known by the Supplier or Supplier Affiliates through no improper action prior to receipt; (2) becomes (through no improper action) generally available to the public; (3) is independently developed by the Supplier or Supplier Affiliates without the use of any McD China Confidential Information for a party other than McD China or McD China Affiliates; or (4) is approved for release by written authorization from McD China.\n" +
      "\n" +
      "5.\t供应商在使用SRM System的过程中，不得携带或者使用任何可能危害SRM System安全的程序和代码，包括但不限于，“秘密通道”，“时间炸弹”，“特洛依木马”，“蠕虫”，“致死程序”，“病毒”。\n" +
      "In the course of using the SRM System, the supplier shall not carry or use any procedures and code that may endanger the safety of the SRM System including, but not limited to, \"secret passage\", \"time bomb\", \"Trojan horse\", \"Worm\", \"lethal program\", \"virus\".\n";
  },
  methods: {
    submitForm(formName) {
      let that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          localLogin(this.ruleForm).then((res) => {
            let user = res.data.user;
            that.userInfo = user;
            let loginAgreementFlag = user.loginAgreementFlag;
            //判断用否是否是供应商用户并且是组用户,并且没有员工工号emplid
            let supplier = user.supplier;
            let emplid = user.emplid;
            if (!!supplier && supplier.type == 'GROUP' && !emplid) {
              if (!supplier.invitationCodeStatus || supplier.invitationCodeStatus == 'OVERTIME') {
                Message({ message: '邀请码已过期!!!', type: "error" });
                return;
              }
            } else {
              Message({ message: '非系统用户登陆失败!!!', type: "error" });
              return;
            }
            if (loginAgreementFlag == 'Y') {
              //that.agreeFlag = true;
            } else {
              //that.agreeFlag = false;
              that.showLoginAgreementDialog = true;
              return;
            }
            that.setLocalStorage(user);
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    agreeMethod: function () {
      //调用后台更改用户loginAgreementFlag标识
      this.showLoginAgreementDialog = false;
      userService.changeLoginAgreementFlag(this.ruleForm.userCd).then(res => {
        if (res.code == '200') {
          this.setLocalStorage(this.userInfo);
        } else {
          Message({ message: res.data, type: "error" });
        }
      });
    },
    setLocalStorage: function (user) {
      //let token ='Bearer '+ user.id_token;
      localStorage.setItem('ms_username', user.name);
      localStorage.setItem('ms_userCd', user.userCd);
      localStorage.setItem('ms_userId', user.tmUserId);
      localStorage.setItem("groupableSupplier", user.groupableSupplier);
      localStorage.setItem("ms_DataScope", JSON.stringify(user.dataScope));

      this.$store.commit(setUser, user);
      //将用户标识存入localStorage
      localStorage.setItem('ms_emplFlag', user.emplFlag);
      //将用户角色存入localStorage
      localStorage.setItem('ms_roles', JSON.stringify(user.roleCodes));
      //将用户权限存入localStorage
      localStorage.setItem('ms_Permission', JSON.stringify(user.funCodes));
      //国际化语言
      if (!!user.userWorkLanguage && (user.userWorkLanguage == 'en_US' || user.userWorkLanguage == 'en-US')) {
        this.$i18n.locale = 'en-US';
        localStorage.setItem('userWorkLanguage', 'en-US');
      } else {
        this.$i18n.locale = 'zh-CN';
        localStorage.setItem('userWorkLanguage', 'zh-CN');
      }
      localStorage.setItem('emplid', user.emplid);
      if (user.supplier) {
        localStorage.setItem('supplierObj', JSON.stringify(user.supplier));
      } else {
        localStorage.removeItem("supplierObj");
      }
      // if (JSON.stringify(user.funCodes).indexOf("QSPI_TODO_QUERY") !== -1) {
      //   this.$router.push('/qspiTodo');
      // } else {
      //   this.$router.push('/mytask');
      // }
      console.log('JSON.stringify(user.funCodes)',JSON.stringify(user.funCodes));
      if (JSON.stringify(user.funCodes).indexOf("ToDoList") !== -1) {
        this.$router.push('/mytask');
        console.log('sp-login/ToDoList/mytask');
      } else if (JSON.stringify(user.funCodes).indexOf("ToDoList") === -1 && JSON.stringify(user.funCodes).indexOf("QSPI_TODO_QUERY") !== -1) {
        this.$router.push('/qspiTodo');
        console.log('sp-login/QSPI_TODO_QUERY/qspiTodo');
      }else{
        this.$router.push('/mytask');
        console.log('sp-login/无/mytask');
      }
    }
  }
}
</script>

<style scoped>
.login-wrap {
  position: relative;
  width: 100%;
  height: 100%;
  background-image: url(../../assets/img/sp_login_bg.png);
  background-repeat: no-repeat;
  /* background-size: 100%;*/
  background-size: 100% 100%;
}
.ms-title {
  width: 100%;
  line-height: 50px;
  text-align: center;
  font-size: 20px;
  color: #fff;
  border-bottom: 1px solid #ddd;
}
.ms-login {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 350px;
  margin: -190px 0 0 -175px;
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.3);
  overflow: hidden;
}
.ms-content {
  padding: 30px 30px;
}
.login-btn {
  text-align: center;
}
.login-btn button {
  width: 100%;
  height: 36px;
  margin-bottom: 10px;
}
.login-tips {
  font-size: 12px;
  line-height: 30px;
  color: #fff;
}
</style>
